export default __webpack_public_path__ + "static/media/appstore.87eab11b.png";